import React from 'react'

const Frontend = () => (
  <div className="col-md skills-cont">
    <label className="skills-title">Frontend</label>
    <div className="row">
      <img
        className="skills-icon"
        src={require('../../shared/icons/react.png')}
      />
    </div>
  </div>
)

export default Frontend
